import ability from './ability'

export const canNavigate = to => to.matched.every(route => {
  if (!route.meta || !route.meta.resource) return true
  return ability.can(route.meta.action || 'read', route.meta.resource)
})

export const _ = undefined
